export const DASHBOARD_TABS = [
  'inbox',
  'social',
  'profile',
  'notifications',
  'subscription',
  'games',
  'reviews',
  'api',
  'byom',
] as const

export type DashboardTab = (typeof DASHBOARD_TABS)[number]

export const DASHBOARD_TAB_LABELS: Record<DashboardTab, string> = {
  inbox: 'auth.dashboard.inbox',
  social: 'auth.dashboard.social',
  profile: 'auth.dashboard.profile',
  notifications: 'auth.dashboard.notifications',
  subscription: 'auth.dashboard.subscription',
  games: 'auth.dashboard.games',
  reviews: 'auth.dashboard.reviews',
  api: 'auth.dashboard.api',
  byom: 'auth.dashboard.byom',
}

export function dashboardTabsForHost(
  notificationSetupEnabled: boolean,
): readonly DashboardTab[] {
  return notificationSetupEnabled
    ? DASHBOARD_TABS
    : DASHBOARD_TABS.filter(tab => tab !== 'notifications')
}

export function dashboardTabForHost(
  value: string | null,
  notificationSetupEnabled: boolean,
): DashboardTab | null {
  if (!isDashboardTab(value))
    return null
  return dashboardTabsForHost(notificationSetupEnabled).includes(value)
    ? value
    : null
}

export function isDashboardTab(value: string | null): value is DashboardTab {
  return !!value && DASHBOARD_TABS.includes(value as DashboardTab)
}

export type DashboardBadgeCounts = {
  inbox: number
  social: number
  games?: number
}

export function dashboardTabBadgeCount(
  tab: DashboardTab,
  counts: DashboardBadgeCounts,
): number {
  if (tab === 'inbox')
    return counts.inbox
  if (tab === 'social')
    return counts.social
  if (tab === 'games')
    return counts.games ?? 0
  return 0
}

export function dashboardBadgeTotal(counts: DashboardBadgeCounts): number {
  return DASHBOARD_TABS.reduce(
    (total, tab) => total + dashboardTabBadgeCount(tab, counts),
    0,
  )
}

export function formatBadgeCount(count: number): string {
  return count > 99 ? '99+' : String(count)
}
